import React, { useCallback, useContext } from 'react';

// DEPENDENCIES
import clsx from 'clsx';
import { useFormikContext } from 'formik';

// GLOBAL VARIABLES
import { ENDPOINTS } from 'endpoints.js';

// GLOBAL FUNCTIONS
import { makePath } from 'functions.js';

// HELPERS
import { UploadContext } from 'core/form/control/types/upload/helpers/uploadContext';

// HOOKS
import useRecordView from 'helpers/getRecordView';

// CORE COMPONENTS
import Form from 'core/form/Form';
import UploadItem from 'core/form/control/types/upload/parts/UploadItem';

// LOCAL COMPONETNS
import AttachmentButton from '../tools/AttachmentButton';

// STYLES
import styles from './spotInstructionAttachments.module.scss';

// MAIN COMPONENT
const SpotInstructionAttachment = ({ attachments, index }) => {

  // FORMIK
  const { values: { arySpotInstruction = [] }, setFieldValue, errors, submitCount } = useFormikContext();

  // HOOKS
  const { isAdd, isView } = useRecordView();

  // CONTEXT
  const { uploads = [] } = useContext(UploadContext) || {};

  // CALLBACKS
  const handleDelete = useCallback(
    () => {
      if (!isAdd && arySpotInstruction[index]?.spot_instruction_id !== '') setFieldValue(`arySpotInstruction[${index}].isUpdated`, true);
    },
    [index, arySpotInstruction, setFieldValue, isAdd]
  );

  // RENDER
  return (
    <>
      {!uploads?.length ? null : (
        <Form.Col
          className={clsx(
            isView && styles.view,
            styles.item
          )}
          cols={{ lg: 24 }}
        >
          {uploads.map((upload, i) => {
            const attachment = attachments?.find(a => a.salesattachment_id === upload.salesattachment_id);
            return (
              <UploadItem
                key={i}
                viewArgs={{
                  endpoint: upload.meta.temp
                    ? makePath(ENDPOINTS.uploads.temp.view, upload.fieldValue?.temp_attachment_id)
                    : makePath(ENDPOINTS.uploads.sales.view, upload.salesattachment_id ?? upload.fieldValue?.salesattachment_id),
                }}
                deleteArgs={{
                  method: 'DELETE',
                  endpoint: upload.meta.temp
                    ? makePath(ENDPOINTS.uploads.temp.delete, upload.fieldValue?.temp_attachment_id)
                    : makePath(ENDPOINTS.uploads.sales.delete, upload.salesattachment_id ?? upload.fieldValue?.salesattachment_id),
                  loadingMessage: 'Removing attachment',
                  errorMessage: 'Unable to remove attachment.',
                  successMessage: 'Attachment was removed successfully.'
                }}
                onDelete={handleDelete}
                {...upload}
                meta={{
                  ...(upload.meta ?? {}),
                  fileName: upload.meta.fileName ?? upload?.salesattachment_filename,
                  uploadedBy: upload.meta.uploadedBy ?? attachment?.updated_by,
                  uploadedOn: upload.meta.uploadedOn ?? attachment?.date_updated,
                }}
                containerClassName={i === 0 ? 'pt-lg-2' : undefined}
              />
            );
          })}
        </Form.Col>
      )}
      {submitCount > 0 ? (
        <div className="text-danger ms-2 mb-3 ps-1">
          {errors?.arySpotInstruction?.[index]?.arySpotInstructionAttachment}
        </div>
      ) : null}
    </>
  )
}
SpotInstructionAttachment.Button = AttachmentButton;

export default SpotInstructionAttachment;
